// Internal-traffic marker for GA4. The marketing site sets the same first-party cookie on
// `.wiseppc.com` (`?internal=on`); GTM's Google tag and our gtag('set') send `traffic_type=internal`
// while it is set, and the GA4 "Internal Traffic" data filter excludes those events.
export const INTERNAL_TRAFFIC_COOKIE = 'wpp_internal';
const MAX_AGE_SECONDS = 34560000;
const COOKIE_DOMAIN = 'wiseppc.com';

export function isInternalTraffic() {
  try {
    return document.cookie.split(';').some((part) => part.trim() === `${INTERNAL_TRAFFIC_COOKIE}=1`);
  } catch {
    return false;
  }
}

export function markInternalTraffic() {
  try {
    const host = location.hostname;
    const sharedDomain = host === COOKIE_DOMAIN || host.endsWith(`.${COOKIE_DOMAIN}`);
    const attrs = [`${INTERNAL_TRAFFIC_COOKIE}=1`, 'path=/', `max-age=${MAX_AGE_SECONDS}`, 'SameSite=Lax'];
    if (sharedDomain) attrs.push(`domain=.${COOKIE_DOMAIN}`);
    if (location.protocol === 'https:') attrs.push('Secure');
    document.cookie = attrs.join('; ');
  } catch {
    // Cookies blocked or unavailable: staff traffic just stays unlabelled.
  }
  labelInternalTraffic();
}

// gtag('set') is what reaches GA: parameters on a repeated gtag('config') call never make it onto
// the page_view events that GA4's history-change tracking sends (checked on dev, 2026-10-08).
export function labelInternalTraffic() {
  if (isInternalTraffic()) window.gtag?.('set', { traffic_type: 'internal' });
}
